import {alpha} from '@mui/material';
import theme from '../../../theme';

export const rfidTableSx = {
    // The shape the other relationship tables use, to the pixel: same radius from the theme rather
    // than a hand-written 10px, and no height of its own - the shared Table already sizes itself, and
    // a 600px override made this one visibly shorter than the tabs beside it.
    root: {
        width: '100%',
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(1),
        overflow: 'hidden',
    },
    addBox: {
        // The whole footer, not a button sitting in it: the row is the affordance, so it spans the
        // card edge to edge under the last table row.
        width: '100%',
        padding: theme.spacing(10 / 8, 16 / 8),
        backgroundColor: theme.palette.background.default,
        borderTop: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
        '&:active': {
            backgroundColor: theme.palette.action.selected,
        },
    },
    table: {
        border: 'none',
        '&.MuiDataGrid-root': {
            border: 'none',
        },
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
            outline: 'none !important',
        },
    },
    addText: {
        color: theme.palette.primary.main,
        fontSize: '0.875rem',
        fontWeight: 400,
    },
    colTitle: {
        textTransform: 'uppercase',
    },
    tag: {
        py: 1,
        px: 2,
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
    },
    tagActive: {
        color: theme.palette.success.dark,
        backgroundColor: alpha(theme.palette.success.dark, 0.1),
    },
    tagBlocked: {
        color: theme.palette.error.dark,
        backgroundColor: alpha(theme.palette.error.dark, 0.1),
    },
};
